export enum UsageMediumType {
    PhysicalCard = 1,
    MobileApplication = 2
}
